import React, { useState } from "react";

const ReviewTab = ({updateReviewTabData,reviewTabData}) => {
    const [showReviewerName, setReviewerName] = useState(Number(reviewTabData.review_is_show_reviewer_name));
    const [showReviewerPicture, setReviewerPicture] = useState(Number(reviewTabData.review_is_show_reviewer_picture));
    const [showReviewerVerifiedBadge, setReviewerVerifiedBadge] = useState(Number(reviewTabData.review_is_show_verified_badge));
    const [showReviewerSource, setReviewerSource] = useState(Number(reviewTabData.review_is_show_review_source));
    const [showDate, setShowDate] = useState(Number(reviewTabData.review_is_show_date));
    const [showRating, setShowRating] = useState(Number(reviewTabData.review_is_show_rating));
    const [showImages, setShowImages] = useState(Number(reviewTabData.review_is_show_images));
    const [showBusinessOwnerReply, setShowBusinessOwnerReply] = useState(Number(reviewTabData.review_is_show_business_owner_reply));

    // Handlers Reviewer Name Change
    const handleReviewerNameChange = (e) => {
        const checked = e.target.checked;
        setReviewerName(checked);
        updateReviewTabData("review_is_show_reviewer_name", checked); 
    };

    // Handlers Reviewer Picture Change
    const handleReviewerPictureChange = (e) => {
        const checked = e.target.checked;
        setReviewerPicture(checked);
        updateReviewTabData("review_is_show_reviewer_picture", checked); 
    };

    // Handlers Reviewer Verified Badge Change
    const handleReviewerVerifiedBadgeChange = (e) => {
        const checked = e.target.checked;
        setReviewerVerifiedBadge(checked);
        updateReviewTabData("review_is_show_verified_badge", checked); 
    };

    // Handlers Reviewer Source Change
    const handleReviewerSourceChange = (e) => {
        const checked = e.target.checked;
        setReviewerSource(checked);
        updateReviewTabData("review_is_show_review_source", checked); 
    };

    // Handlers Show Date Change
    const handleShowDateChange = (e) => {
        const checked = e.target.checked;
        setShowDate(checked);
        updateReviewTabData("review_is_show_date", checked); 
    };

    // Handlers Show Rating Change
    const handleShowRatingChange = (e) => {
        const checked = e.target.checked;
        setShowRating(checked);
        updateReviewTabData("review_is_show_rating", checked); 
    };

    // Handlers Show Images Change
    const handleShowImagesChange = (e) => {
        const checked = e.target.checked;
        setShowImages(checked);
        updateReviewTabData("review_is_show_images", checked); 
    };

    // Handlers Show Rating Change
    const handleShowBusinessOwnerReplyChange = (e) => {
        const checked = e.target.checked;
        setShowBusinessOwnerReply(checked);
        updateReviewTabData("review_is_show_business_owner_reply", checked); 
    };

    return (
        <div className="side-baar-inner-header">
            <span>Review</span>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Show Reviewer Name</span>
                    <div className="form-group">
                        <input id="review_style_reviewer_name_toggle" className="chkbx-toggle" type="checkbox" checked={showReviewerName} onChange={handleReviewerNameChange} />
                        <label for="review_style_reviewer_name_toggle"></label>
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Show Reviewer Picture</span>
                    <div className="form-group">
                        <input id="review_style_reviewer_picture_toggle" className="chkbx-toggle" type="checkbox" checked={showReviewerPicture} onChange={handleReviewerPictureChange}/>
                        <label for="review_style_reviewer_picture_toggle"></label>
                    </div>
                </div>
                <div className="box-header-row last-border-none">
                    <span>Show Verified Badge</span>
                    <div className="form-group">
                        <input id="review_style_verified_badge_toggle" className="chkbx-toggle" type="checkbox" checked={showReviewerVerifiedBadge} onChange={handleReviewerVerifiedBadgeChange} />
                        <label for="review_style_verified_badge_toggle"></label>
                    </div>
                </div>
            </div>

            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Show Reviewer Source</span>
                    <div className="form-group">
                        <input id="review_style_reviewer_source_toggle" className="chkbx-toggle" type="checkbox" checked={showReviewerSource} onChange={handleReviewerSourceChange} />
                        <label for="review_style_reviewer_source_toggle"></label>
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Show Date</span>
                    <div className="form-group">
                        <input id="review_style_show_date_toggle" className="chkbx-toggle" type="checkbox" checked={showDate} onChange={handleShowDateChange} />
                        <label for="review_style_show_date_toggle"></label>
                    </div>
                </div>
                <div className="box-header-row last-border-none">
                    <span>Show Rating</span>
                    <div className="form-group">
                        <input id="review_style_show_rating_toggle" className="chkbx-toggle" type="checkbox" checked={showRating} onChange={handleShowRatingChange} />
                        <label for="review_style_show_rating_toggle"></label>
                    </div>
                </div>
            </div>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Show Images</span>
                    <div className="form-group">
                        <input id="review_style_show_image_toggle" className="chkbx-toggle" type="checkbox" checked={showImages} onChange={handleShowImagesChange} />
                        <label for="review_style_show_image_toggle"></label>
                    </div>
                </div>
                <div className="box-header-row last-border-none">
                    <span>Show Business Owner Reply</span>
                    <div className="form-group">
                        <input id="review_style_business_owner_reply_toggle" className="chkbx-toggle" type="checkbox" checked={showBusinessOwnerReply} onChange={handleShowBusinessOwnerReplyChange} />
                        <label for="review_style_business_owner_reply_toggle"></label>
                    </div>
                </div>
            </div>
            <p>If you show images or owner replies in reviews, Read More will open details in a popup.</p>
            <div className="side-baar-box-header">
                <div className="box-header-row last-border-none">
                    <span>Reviewer Name Format</span>
                    <div className="salcete-font">
                        <button><em>John Smith <i className="fa fa-caret-down" aria-hidden="true"></i></em></button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReviewTab;